import { render, staticRenderFns } from "./addKltg.vue?vue&type=template&id=338047be"
import script from "./addKltg.vue?vue&type=script&lang=js"
export * from "./addKltg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports